import React from "react";
import {
  Newspaper, CalendarDays, ExternalLink, Facebook, Award, GraduationCap, Megaphone,
} from "lucide-react";
import { Button } from "./ui/button";

const FB_POST_URL =
  "https://www.facebook.com/MicheleRoccaroOfficial/posts/pfbid02mDPEx5g4rfzBJjqVYiS65kcYB5mnBEwTCw8gWANi63sZyRd83AES8v4fyqTkZ8PMl";

const FB_EMBED_SRC =
  "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FMicheleRoccaroOfficial%2Fposts%2Fpfbid02mDPEx5g4rfzBJjqVYiS65kcYB5mnBEwTCw8gWANi63sZyRd83AES8v4fyqTkZ8PMl&show_text=true&width=500";

const PRESS_ARTICLES = [
  {
    source: "Video Regione Sicilia",
    date: "01 Giugno 2026",
    title:
      "Michele Roccaro premiato con la \u201cStella di E.S.S.E. 2026\u201d: riconosciuto il suo impegno nell\u2019innovazione, nella formazione e nell\u2019aver creato con un team di professionisti la prima figura professionale sul digitale regolamentata e certificata",
    excerpt:
      "Il prestigioso riconoscimento nazionale conferito dall'Ente Sportivo Sociale Europeo (E.S.S.E.) per il contributo alla crescita sociale, culturale e professionale del territorio. La cerimonia si svolge a Roma, presso Palazzo Valentini.",
    url: "https://www.vrsicilia.it/michele-roccaro-premiato-con-la-stella-di-e-s-s-e-2026-riconosciuto-il-suo-impegno-nellinnovazione-e-nella-formazione/",
    tag: "Riconoscimento",
    icon: Award,
  },
];

const UPCOMING_EVENTS = [
  { title: "Masterclass Consulente Digitale", status: "In programmazione", icon: GraduationCap },
  { title: "Workshop Tutela del Consumatore", status: "In programmazione", icon: Megaphone },
  { title: "Convegno Sostenibilit\u00e0 Digitale", status: "In programmazione", icon: CalendarDays },
];

export default function PressEvents() {
  return (
    <section id="rassegna-stampa" className="relative py-24 md:py-28 bg-gradient-to-b from-white via-[#f5f7ff] to-white overflow-hidden">
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#f59e0b]/10 blur-3xl"></div>
      <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#102a6b]/10 blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-slate-200 text-[12px] font-semibold text-[#102a6b] shadow-sm">
              <Newspaper className="h-3.5 w-3.5 text-[#f59e0b]" />
              Rassegna Stampa &amp; Eventi
            </div>
            <h2 className="mt-4 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
              Ne hanno parlato.<br className="hidden md:block" /> Le voci dell&apos;<span className="text-[#102a6b]">Associazione</span>.
            </h2>
            <p className="mt-4 text-slate-600 text-lg leading-relaxed">
              Articoli, interviste, eventi e attività che raccontano la missione di A.C.D.T. e
              il lavoro dei suoi membri nel mondo digitale, tecnologico e della sostenibilità.
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] font-bold text-slate-500">
            <CalendarDays className="h-4 w-4 text-[#f59e0b]" />
            Ultimi aggiornamenti
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-start">
          {/* Press articles + FB Post */}
          <div className="lg:col-span-7 reveal space-y-6">
            {/* Press article card */}
            {PRESS_ARTICLES.map((a) => {
              const Icon = a.icon;
              return (
                <article
                  key={a.url}
                  className="rounded-3xl border border-slate-200 bg-white p-6 md:p-8 shadow-[0_24px_70px_-30px_rgba(16,42,107,0.25)] lift"
                >
                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <div className="flex items-center gap-3">
                      <div className="h-11 w-11 rounded-xl bg-[#102a6b] text-white flex items-center justify-center">
                        <Icon className="h-5 w-5" />
                      </div>
                      <div>
                        <div className="text-[11px] uppercase tracking-wider font-bold text-[#f59e0b]">
                          {a.tag}
                        </div>
                        <div className="text-[13px] font-semibold text-slate-600">
                          {a.source} • {a.date}
                        </div>
                      </div>
                    </div>
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#f59e0b]/15 text-[#b45309] text-[11px] font-bold uppercase tracking-wider">
                      <Award className="h-3.5 w-3.5" />
                      Stella di E.S.S.E. 2026
                    </span>
                  </div>

                  <h3 className="mt-5 text-xl md:text-2xl font-extrabold text-[#0a1f55] leading-tight">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed text-[14.5px]">
                    {a.excerpt}
                  </p>

                  <div className="mt-5 flex items-center justify-between gap-3 flex-wrap pt-5 border-t border-slate-100">
                    <div className="flex items-center gap-2 text-[12.5px] text-slate-500">
                      <ExternalLink className="h-3.5 w-3.5" />
                      <span>Fonte: vrsicilia.it</span>
                    </div>
                    <a href={a.url} target="_blank" rel="noreferrer">
                      <Button className="bg-[#102a6b] hover:bg-[#0a1f55] text-white">
                        Leggi l&apos;articolo
                        <ExternalLink className="ml-2 h-4 w-4" />
                      </Button>
                    </a>
                  </div>
                </article>
              );
            })}

            {/* Facebook embedded post */}
            <article className="rounded-3xl border border-slate-200 bg-white p-6 md:p-8 shadow-[0_24px_70px_-30px_rgba(16,42,107,0.25)]">
              <div className="flex items-center gap-3 mb-5">
                <div className="h-10 w-10 rounded-lg bg-[#1877F2]/10 text-[#1877F2] flex items-center justify-center">
                  <Facebook className="h-5 w-5" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-wider font-bold text-[#f59e0b]">
                    Articolo in evidenza
                  </div>
                  <div className="text-[15px] font-bold text-[#0a1f55]">Post da Facebook</div>
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden border border-slate-200 bg-white">
                {/* Clean custom header (covers original FB author "Roccaro Michele Due") */}
                <div className="bg-white border-b border-slate-200 px-4 py-3 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-[#102a6b] text-white flex items-center justify-center font-extrabold text-sm shrink-0">
                    MR
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[14.5px] font-bold text-[#0a1f55] truncate">
                      Michele Roccaro
                    </div>
                    <div className="text-[11.5px] text-slate-500">
                      Fondatore A.C.D.T. • Articolo in evidenza
                    </div>
                  </div>
                  <Facebook className="h-5 w-5 text-[#1877F2] shrink-0" />
                </div>

                {/* Iframe wrapper: cropped to hide FB's original author header */}
                <div className="relative overflow-hidden flex justify-center bg-white" style={{ height: 720 }}>
                  <iframe
                    src={FB_EMBED_SRC}
                    title="Post Facebook A.C.D.T."
                    width="500"
                    height="800"
                    className="border-0 max-w-full block"
                    style={{ border: "none", overflow: "hidden", marginTop: "-78px" }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  ></iframe>
                </div>
              </div>

              <div className="mt-5 flex items-center justify-between gap-3 flex-wrap">
                <p className="text-[12.5px] text-slate-500 max-w-md">
                  Contenuto pubblicato su Facebook. Clicca su &quot;Apri post&quot; per leggerlo direttamente
                  sulla piattaforma.
                </p>
                <a href={FB_POST_URL} target="_blank" rel="noreferrer">
                  <Button variant="outline" className="border-slate-300 text-[#102a6b] hover:bg-[#102a6b]/5 hover:text-[#102a6b]">
                    Apri post
                    <ExternalLink className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </div>
            </article>
          </div>

          {/* Sidebar */}
          <aside className="lg:col-span-5 reveal space-y-5">
            <div className="rounded-2xl bg-[#0a1f55] text-white p-7 relative overflow-hidden">
              <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#f59e0b]/25 blur-3xl"></div>
              <div className="relative">
                <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#fbbf24]">
                  Coming soon
                </div>
                <h3 className="mt-2 text-2xl font-extrabold leading-tight">
                  Prossimi Eventi A.C.D.T.
                </h3>
                <p className="mt-3 text-slate-300 leading-relaxed text-[14px]">
                  Stiamo organizzando incontri, masterclass e workshop su digitale, tecnologia e
                  sostenibilità. Il calendario completo sarà pubblicato a breve.
                </p>
                <ul className="mt-5 space-y-3">
                  {UPCOMING_EVENTS.map((e) => {
                    const EIcon = e.icon;
                    return (
                      <li
                        key={e.title}
                        className="flex items-center gap-4 rounded-xl bg-white/[0.05] border border-white/10 p-3"
                      >
                        <div className="h-11 w-11 rounded-lg bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center shrink-0">
                          <EIcon className="h-5 w-5" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-[14px] font-bold text-white truncate">{e.title}</div>
                          <div className="text-[11px] text-slate-300 mt-0.5">{e.status}</div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="rounded-2xl bg-white border border-slate-200 p-7">
              <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#f59e0b]">
                Press kit
              </div>
              <h3 className="mt-2 text-xl font-extrabold text-[#0a1f55]">
                Per i media e i giornalisti
              </h3>
              <p className="mt-3 text-[13.5px] text-slate-600 leading-relaxed">
                Sei un giornalista o operatore della comunicazione? Scrivici per richiedere
                interviste, materiali, comunicati stampa e immagini ufficiali dell&apos;Associazione.
              </p>
              <a href="mailto:acdt@centrostudiesse.it" className="mt-4 inline-block">
                <Button className="bg-[#102a6b] hover:bg-[#0a1f55] text-white">
                  Contatta l&apos;ufficio stampa
                </Button>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
